export const GET_POST_WATCHER = 'GET_POST_WATCHER';
export const GET_POST_SUCCESS = 'GET_POST_SUCCESS';
export const GET_POST_FAILED = 'GET_POST_FAILED';
